var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.89285714,14 L6.89285714,9.92857143 L8.73901099,9.92857143 C10.2005495,9.92857143 11.3502747,9.5782967 12.1881868,8.87774725 C13.0260989,8.1771978 13.4450549,7.24175824 13.4450549,6.07142857 C13.4450549,5.28021978 13.2513736,4.5728022 12.864011,3.94917582 C12.4766484,3.32554945 11.9299451,2.84478022 11.2239011,2.50686813 C10.5178571,2.16895604 9.70604396,2 8.78846154,2 L4,2 L4,14 L6.89285714,14 Z M6.89285714,7.69505495 L6.89285714,4.23351648 L8.82142857,4.23351648 C9.34340659,4.23901099 9.75549451,4.40934066 10.0576923,4.74450549 C10.3598901,5.07967033 10.510989,5.52747253 10.510989,6.08791209 C10.510989,6.5989011 10.364011,6.99450549 10.0700549,7.27472527 C9.7760989,7.55494505 9.3489011,7.69505495 8.78846154,7.69505495 L6.89285714,7.69505495 Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/parking.5332ade80a21215ce0d05ef98ebd3b49.svg";
export { ForwardRef as ReactComponent };